import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2.01L2 22l4-4h16V2zm-9 12h-2v-2h2v2zm0-4h-2V6h2v4z"
}), 'FeedbackSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FeedbackSharp.js
// module id = 3542
// module chunks = 2